var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.case_
        ? [
            _c(
              "div",
              { staticClass: "panel wraper", class: _vm.statusClass },
              [
                _c(
                  "div",
                  { staticClass: "panel-header" },
                  [
                    _c(
                      "transition",
                      {
                        attrs: {
                          name: _vm.transName || "slide-l",
                          mode: "out-in"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            key: _vm.$route.params.id,
                            staticClass: "panel-title"
                          },
                          [
                            _vm.$route.name === "instrumentCaseView"
                              ? _c("span", [
                                  _vm._v("Кейс № " + _vm._s(_vm.case_.label))
                                ])
                              : _c("unit-path", {
                                  attrs: {
                                    id: _vm.case_.parent_id,
                                    lbl: "Кейс № " + _vm.case_.label
                                  }
                                })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "transition",
                  {
                    attrs: { name: _vm.transName || "slide-l", mode: "out-in" }
                  },
                  [
                    _c(
                      "div",
                      { key: _vm.$route.params.id, staticClass: "panel-body" },
                      [
                        _vm.case_.lastEdited
                          ? _c("p", { staticClass: "in-top" }, [
                              _c(
                                "small",
                                { staticClass: "view-label" },
                                [
                                  _c("q-icon", {
                                    attrs: { name: "fas fa-user-edit" }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.editor) +
                                      " " +
                                      _vm._s(
                                        _vm._f("formatTime")(
                                          _vm.case_.lastEdited
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", [
                          _c("span", { staticClass: "text-bolder" }, [
                            _vm._v(
                              _vm._s(_vm.case_.statusLabel) +
                                " " +
                                _vm._s(_vm.workDateLabel)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.case_.problem
                          ? _c("p", [
                              _c("small", { staticClass: "view-label" }, [
                                _vm._v("Проблема")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-bolder" }, [
                                _vm._v(_vm._s(_vm.case_.problem))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.case_.master
                          ? _c("p", [
                              _c("small", { staticClass: "view-label" }, [
                                _vm._v("Исполнитель")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-bolder" }, [
                                _vm._v(_vm._s(_vm.masterName))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.case_.result
                          ? _c("p", [
                              _c("small", { staticClass: "view-label" }, [
                                _vm._v("Результат")
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-bolder" }, [
                                _vm._v(_vm._s(_vm.case_.result))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.case_.raw
                          ? _c("request-card", {
                              attrs: { request: _vm.case_.raw }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("media-bar", {
                          attrs: { medias: _vm.mediasCopy },
                          on: { selectMedia: _vm.showAttach }
                        }),
                        _vm._v(" "),
                        _vm.case_.works
                          ? _c("p", { staticClass: "subtitle" }, [
                              _vm._v(
                                "\n            Работы (" +
                                  _vm._s(_vm.case_.works.length) +
                                  ")\n          "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "panel-list" },
                          _vm._l(_vm.sortedWorks, function(item, ind) {
                            return _c("work-item", {
                              key: ind,
                              attrs: { item: item }
                            })
                          })
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.notReader
              ? _c("pop-btn", {
                  staticClass: "mobile-hide",
                  attrs: { btns: _vm.btns }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.notReader
              ? _c("pop-hold", {
                  staticClass: "mobile-only",
                  attrs: { btns: _vm.btns }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("media-modal", {
              ref: "mediaModal",
              attrs: { done: _vm.createAttach }
            })
          ]
        : [_c("div", [_c("spinner", { attrs: { name: "dots" } })], 1)],
      _vm._v(" "),
      _c("mediator", {
        ref: "mediator",
        attrs: { editEnabled: _vm.notReader },
        on: {
          mediaEdited: _vm.mediaEdited,
          mediaDeleted: _vm.mediaDeleted,
          doNext: _vm.doNext
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5715c062", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5715c062","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/case-view.vue
// module id = null
// module chunks = 